<template>
  <div>
    <CContainer class="mb-4">
      <CRow>
        <CCol md="3">
          <CButton 
            :disabled="showcases.length >= 4" 
            class="w-100" 
            color="success" 
            @click="() => { $router.push({path: '/config/create-showcase'}) }"
          >
            <div class="button-text">
              <CIcon name="cil-plus" />
              <span>New</span>
            </div>
          </CButton>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Loader -->
    <CContainer class="d-flex justify-content-center" v-if="isLoad">
      <CSpinner color="primary" size="lg"/>
    </CContainer>
    <CContainer v-else>
      <CRow>
        <CCol 
          md="12"
          v-for="showcase in showcases" 
          :key="showcase.id"
        >
          <CCard>
            <CCardBody>
              <CRow>
                <CCol sm="12">
                  <h5>{{ showcase.sectionTitle }}</h5>
                  <h5 class="mb-3">{{ showcase.chineseTitle || '-'}}</h5>
                </CCol>
              </CRow>
              <CRow>
                <CCol
                  sm="3"
                  class="mb-3 d-flex justify-content-flex-start"
                  v-for="list in showcase.list"
                  :key="list.id"
                >
                  <CCard>
                    <CCardBody class="p-2">
                      <CImg 
                        alt="Product Image" 
                        :src="list.image[0]" 
                        class="w-100 mb-3"
                      />
                      <CCardSubtitle class="mb-3">{{ list.name }}</CCardSubtitle>
                      <CCardSubtitle>{{ moneyFormatter(list.price) }}</CCardSubtitle>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6">
                  <h5 class="mb-3">Button Text</h5>
                  <CButton class="mb-2 w-75" block color="light" shape="pill" disabled>{{ showcase.button.text }}</CButton>
                  <CButton class="mb-2 w-75" block color="light" shape="pill" disabled>{{ showcase.button.chineseText || '-' }}</CButton>
                </CCol>
                <CCol sm="6">
                  <h5 class="mb-3">Redirect Link</h5>
                  <p>{{ showcase.button.redirectUrl }}</p>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <CButton 
                color="danger" 
                variant="ghost" 
                @click="() => { 
                  modalVisible.delete = true 
                  id = showcase.id
                }"
              >
                <div class="button-text">
                  <CIcon name="cil-trash" />
                  <span>Delete</span>
                </div>
              </CButton>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Modal -->
    <CModal
      title="Modal title"
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="modalVisible.delete"
    >
      Are you sure you want to delete this item ?
      <template #header>
        <h5 class="modal-title">Delete Banner</h5>
        <CButtonClose @click="dismissModal" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="handleDelete(id)" color="danger">OK</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import {
  CONFIG_GET,
  SHOWCASE_DELETE
} from '../../../constants/api'
import moneyFormatter from '../../../utils/moneyFormatter'

import axios from 'axios'

export default {
  data () {
    return {
      moneyFormatter,
      id: '',
      showcases: [],
      modalVisible: {
        delete: false,
      },
      isLoad: false,
      accessToken: sessionStorage.getItem('access_token') || '',
    }
  },

  beforeMount () {
    this.fetchConfig()
  },

  methods: {
    fetchConfig () {
      this.isLoad = true

      axios.get(`${CONFIG_GET}/home_showcase_options`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(res => {
          this.showcases = res.data.data
          this.isLoad = false
          this.dismissModal()
        })
    },

    handleDelete (id) {
      axios.delete(`${SHOWCASE_DELETE}/${id}`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchConfig())
    },

    dismissModal () {
      this.id = ''
      this.modalVisible.delete = false
    },
  }
}
</script>

<style scoped>
  .button-text {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button-text > span {
    margin-left: 6px;
  }
</style>